import { useState, useCallback } from "react";

import { getPatientProfileDetailApi } from "../apis/patient/profile";

export const usePatientProfile = () => {
  const [profileDetail, setProfileDetail] = useState<{
    name: string;
    age: string;
    gender: string;
    mobileNo: string;
    is_default: boolean;
  } | null>(null);

  const [isProfileLoading, setIsProfileLoading] = useState(false);

  const fetchPatientProfileDetail = async (selectedMemberId?: string) => {
    setIsProfileLoading(true);
    try {
      const response = await getPatientProfileDetailApi();
      if ("result" in response) {
        const member = response.result.members.find((member) =>
          selectedMemberId ? member.id === selectedMemberId : member.is_default
        );

        if (member) {
          const { name, age, gender, phone_number, is_default } = member;
          setProfileDetail({
            name,
            age: age?.toString(),
            gender,
            mobileNo: phone_number!,
            is_default,
          });
        }
        return response.result;
      }
    } catch (error) {
      console.error("Error fetching patient profile:", error);
    } finally {
      setIsProfileLoading(false);
    }
  };

  return {
    profileDetail,
    setProfileDetail,
    isProfileLoading,
    fetchPatientProfileDetail,
  };
};
